import { api } from "./configs/axiosConfigs"

export const UserTypeAPI = {
    getUserType: async (data:any) => {
        const response = await api.get(
            '/user/listUserType', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getPrivilege: async (data:any) => {
        const response = await api.get(
            '/user/listPrivilege', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}